import { Component, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Button } from 'reactstrap';
import { Form } from 'react-bootstrap';
import Select from 'react-select';
import Alert from 'react-bootstrap/Alert';

import { AuthenticationContext } from '../../../msal/AuthenticationContext';
import { TenantContext } from '../../../context/TenantContext';
import { ButtonWithDisabledTooltip } from '../../../components/ButtonWithDisabledTooltip';
import * as apiCalls from '../../../logic/apiCalls';

class ModalDeviceAddOrUpdateInternal extends Component {
    state = {
        deviceId: "",
        deviceName: "",
        description: "",
        sipExtension: "",
        sipUsername: "",
        sipPassword: "",
        groupsOptions: [],
        selectedGroupOption: null,
        successfullScan: false,
    }

    constructor(props) {
        super(props);

        // Build the description validation Regex.
        let nonPrintableCharStart = String.fromCharCode(0x00); // NULL char
        let nonPrintableCharEnd = String.fromCharCode(0x1F); // S7 char
        let delRegex = String.fromCharCode(0xF); // DEL char
        let backslashRegex = "\\\\"; // The parsing of the literal string will reduce this to 2 backslashes, the parsing of this string by the RegExp class will reduce it to a single literal backslash to be matched.
        let forwardslashRegex = "\\/"; 
        let bracketOpeningRegex = "\\["; 
        let bracketClosingRegex = "\\]"; 
        let quotationRegex = "\\\""; 
        let additionalCharsRegex = "!@#$%^&*()={};:";
        
        this.descriptionValidationRegex = new RegExp(`^[^${nonPrintableCharStart}-${nonPrintableCharEnd}${delRegex}${backslashRegex}${forwardslashRegex}${bracketOpeningRegex}${bracketClosingRegex}${quotationRegex}${additionalCharsRegex}]*$`);
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.isOpen && this.props.isOpen) {
            this.setInitialValues();
            this.retrieveContactGroups();
        }
    }

    setInitialValues = () => {
        const isUpdate = this.props.isUpdate;

        this.setState(
            {
                deviceId: isUpdate ? this.props.deviceToUpdate.deviceId : "",
                deviceName: isUpdate ? this.props.deviceToUpdate.deviceName : "",
                description: isUpdate ? this.props.deviceToUpdate.deviceDescription : "",
                sipExtension: isUpdate ? this.props.deviceToUpdate.sipExtension : "",
                sipUsername: isUpdate ? this.props.deviceToUpdate.sipUsername : "",
                sipPassword: isUpdate ? this.props.deviceToUpdate.sipPassword : "",
            }
        );
    }

    retrieveContactGroups = async () => {
        const contactGroups = await apiCalls.getContactGroups(this.props.authenticationContext, this.props.tenantContext.tenantId);

        this.extractGroupStateFromData(contactGroups);
    }

    extractGroupStateFromData = (contactGroups) => {

        var contactGroupOptions = [];
        var selectedContactGroupOption = null;

        contactGroups.forEach(contactGroup => {
            var groupFilterOption = {value:contactGroup.groupId, label:contactGroup.name};
            contactGroupOptions.push(groupFilterOption);

            if (this.props.isUpdate && this.props.deviceToUpdate.groupId === contactGroup.groupId) {
                selectedContactGroupOption = groupFilterOption
            }
        });

        this.setState({
            groupsOptions: contactGroupOptions,
            selectedGroupOption: selectedContactGroupOption,
        });
    }

    handleDoneButtonClicked = () => {
        const deviceName = this.props.deviceNameToAdd ? this.props.deviceNameToAdd : this.state.deviceName;
        const trimmedDeviceName = deviceName.trim();
        const trimmedDescription = this.state.description.trim();

        const doneInfo = {
            deviceId: this.state.deviceId,
            name: trimmedDeviceName,
            description: trimmedDescription,
            groupId: this.state.selectedGroupOption?.value,
            isUpdate: this.props.isUpdate
        }

        this.props.onAddOrUpdate(doneInfo);
    }

    handleDeviceNameChanged = (e) => {
        const updatedDeviceName = e.target.value;

        if (updatedDeviceName.length > 0 && !this.descriptionValidationRegex.test(updatedDeviceName)) {
            return;
        }
                
        this.setState({
            deviceName: updatedDeviceName
        });
    }

    handleDescriptionChanged = (e) => {
        const updatedDescription = e.target.value;

        if (updatedDescription.length > 0 && !this.descriptionValidationRegex.test(updatedDescription)) {
            return;
        }
                
        this.setState({
            description: updatedDescription
        });
    }

    handleSelectedGroupChange = (selectedGroupOption) => {
        if (!this.state.selectedGroupOption || !selectedGroupOption || this.state.selectedGroupOption.value !== selectedGroupOption.value) {
            this.setState(
                {
                    selectedGroupOption: selectedGroupOption
                }
            );
        }
    }

    shouldAddOrUpdateButtonBeEnabled = () => {
        return this.getAddOrUpdateButtonTooltip() === null;
    }

    getAddOrUpdateButtonTooltip = () => {
        if (!this.props.isOpen) {
            return null;
        }

        if (!this.props.isUpdate && (!this.props.isSubscriptionAvailable || !this.props.islicenseAvailable)) {
            return "No license available for a new device.";
        }

        const deviceName = this.props.deviceNameToAdd ? this.props.deviceNameToAdd : this.state.deviceName;

        if (deviceName === '') {
            return "Namemay not be empty";
        }

        if (deviceName.length > 36) {
            return "Name must be less than 36 characters";
        }

        if (this.state.description === '') {
            return "Description may not be empty";
        }

        if (this.state.description.length > 256) {
            return "Description must be less than 256 characters";
        }

        if (!this.props.isUpdate) {
            return null;
        }

        const descriptionChanged = this.state.description !== this.props.deviceToUpdate.deviceDescription;
        const groupOptionChanged = (this.state.selectedGroupOption ? this.state.selectedGroupOption.value : null) !== this.props.deviceToUpdate.groupId;

        if (descriptionChanged ||
            groupOptionChanged)
        {
            return null;
        }

        return "No changes detected";
    }

    render() {
        const deviceName = this.props.deviceNameToAdd ? this.props.deviceNameToAdd : this.state.deviceName;
        const headerText = this.props.isUpdate ? 'Update Device' : 'Add Device';
        const doneButtonText = this.props.isUpdate ? 'Update' : 'Add';
        const deviceNameDisabled = this.props.isUpdate || this.props.deviceNameToAdd ? true : false || this.state.successfullScan;

        const licensesWarningRendered = this.props.isSubscriptionAvailable ? this.props.islicenseAvailable ? null : 
            <Alert variant='warning' style={{ opacity: 1 }}>
                Not enough licenses available to add a new device. Please increase the quantity of your subscription before adding a new device.
            </Alert> :
            <Alert variant='warning' style={{ opacity: 1 }}>
                No available subscription is found. Please contact Robin Telecom to subscribe to the service.
            </Alert>;

        return <Modal show={this.props.isOpen} onHide={this.props.onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{headerText}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {licensesWarningRendered}
                <Form className="mt-3" onSubmit={e => e.preventDefault()}>
                    <Form.Group controlId="newDeviceName">
                        <Form.Label>Name</Form.Label>
                        <Form.Control type="text" placeholder="Enter name" disabled={deviceNameDisabled} readonly={deviceNameDisabled} value={deviceName} autoComplete="off" onChange={this.handleDeviceNameChanged} />
                    </Form.Group>
                    <Form.Group controlId="newDeviceDescription">
                        <Form.Label>Description</Form.Label>
                        <Form.Control type="text" placeholder="Enter description" value={this.state.description} autoComplete="off" onChange={this.handleDescriptionChanged} />
                    </Form.Group>
                    <Form.Group controlId="newDeviceSipUsername">
                        <Form.Label>SIP Username</Form.Label>
                        <Form.Control type="text" disabled={true} value={this.state.sipUsername} />
                    </Form.Group>
                    <Form.Group controlId="newDeviceContactGroup">
                        <Form.Label>Contact Group</Form.Label>
                        <Select isSearchable={true} isClearable={true} value={this.state.selectedGroupOption} options={this.state.groupsOptions} onChange={this.handleSelectedGroupChange} placeholder='Select contact group...' />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button color="secondary" onClick={this.props.onHide}>Cancel</Button>
                <ButtonWithDisabledTooltip color="primary" disabled={!this.shouldAddOrUpdateButtonBeEnabled()} disabledTooltip={this.getAddOrUpdateButtonTooltip()} onClick={this.handleDoneButtonClicked}>{doneButtonText}</ButtonWithDisabledTooltip>{' '}
            </Modal.Footer>
        </Modal>;
    }
}

export const ModalDeviceAddOrUpdate = (props) => {
    const authenticationContext = useContext(AuthenticationContext);
    const tenantContext = useContext(TenantContext);

    return (
        <ModalDeviceAddOrUpdateInternal authenticationContext={authenticationContext} tenantContext={tenantContext} {...props}/>
    )
}